import React, {Button, Component, useState } from "react";

import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import AddUser from "../../services/addUser";
import TimezoneSelect from "../../widgets/TimezoneSelect";

var moment_tz = require('moment-timezone');

export default class AddUserToSystem extends React.Component {

  constructor(props){
    super (props)
  
    this.tzRef = React.createRef();

    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      selectedTimezone: {
        value: 'America/Juneau',
        label: '(GMT-8:00) Alaska (AHDT)',
        altName: 'Alaskan Daylight Time',
        abbrev: 'AHDT'
      },
    }

    this.grid = 2;

    this.pageTitle = "Add User";

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

//    this.setState({});
  }

  render () {

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          
          <TextInput name={'Username '} value={this.state.username} 
            onChange={(text) => { this.setState({username: text})}
          } />
          <TextInput name={'Name '} value={this.state.name} 
            onChange={(text) => { this.setState({name: text})}
          } />
          <TextInput name={'Surname '} value={this.state.surname} 
            onChange={(text) => { this.setState({surname: text})}
          } />
          <TextInput name={'Password '} type={"password"} value={this.state.password} 
            onChange={(text) => { this.setState({password: text})}
          } />
          <TextInput name={'Password confirm'} type={"password"} value={this.state.confirm} 
            onChange={(text) => { this.setState({confirm: text})}
          } />
        
          <TimezoneSelect ref={this.tzRef} name={'Timezone'} handleChange={(val) => {alert (this.tzRef.current.getValue())}}/>

          <FixButton title={'Save'} callback={async (value) => {

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });

            await AddUser(username, token, this.state.name,
                          this.state.surname,
                          this.state.username,
                          this.state.password,
                          1);

            window.location.href = '/';
          
          }} />

        </LoadingOverlay>
      </>
    );
  }

}

